import { render, staticRenderFns } from "./CFileUploadArea.vue?vue&type=template&id=98d1b230&scoped=true&"
import script from "./CFileUploadArea.vue?vue&type=script&lang=ts&"
export * from "./CFileUploadArea.vue?vue&type=script&lang=ts&"
import style0 from "./CFileUploadArea.vue?vue&type=style&index=0&id=98d1b230&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d1b230",
  null
  
)

export default component.exports